import { supportEmail, VERSION_HASH } from '../config/constants';
import useCopy from '../util/useCopy';
import Action from './Action';
import Button from './Button';

export let ErrorPage = () => {
  let copy = useCopy();
  return (
    <div className="!bg-neutral-0 h-full">
      <div className="py-8 px-6 text-purple-900">
        <p>{copy.appCrashed}</p>
        <Button
          className="w-full"
          onClick={() => {
            window.location.assign(window.location.origin);
          }}
        >
          {copy._Reload}
        </Button>
      </div>
      <div className="py-8 px-6 text-purple-900">
        <p>{copy['If this keeps happening, please']}</p>
        <Action
          className="w-full"
          onClick={() => {
            window.open(`mailto:${supportEmail}`);
          }}
        >
          {copy['Email me']}
        </Action>
      </div>
      <img
        className="absolute bottom-0 w-full"
        src={'/assets/crashed_car.png'}
        alt={copy['Crash scene from "Chitty Chitty Bang Bang"']}
      />
      {VERSION_HASH && (
        <div className="absolute bottom-2 right-2 text-xs text-purple-300 opacity-50">
          {VERSION_HASH}
        </div>
      )}
    </div>
  );
};

export default ErrorPage;
